import React, { useId } from 'react'
import { Switch } from '@mui/material'

import { INTERAX_COLORS } from '../../../constants/colors'
import { useTranslation } from '../../../shared/hooks/useIntractionTranslate'
import type { SettingsField } from '../types'
import { SettingFieldRow } from './SettingFieldRow'

export interface SettingToggleRowProps {
  field: SettingsField
  value: boolean
  onChange: (value: boolean) => void
  disabled?: boolean
}

/** Renders a `toggle` field as a themed MUI Switch (amber when on). */
export const SettingToggleRow: React.FC<SettingToggleRowProps> = ({ field, value, onChange, disabled }) => {
  const { t } = useTranslation()
  const id = useId()
  const isDisabled = disabled || field.disabled
  const label = t(field.labelKey)

  return (
    <SettingFieldRow
      label={label}
      description={field.descriptionKey ? t(field.descriptionKey) : undefined}
      htmlFor={id}
      disabled={isDisabled}
      control={
        <Switch
          id={id}
          checked={value}
          disabled={isDisabled}
          onChange={(e) => onChange(e.target.checked)}
          inputProps={{ 'aria-label': label }}
          sx={{
            '& .MuiSwitch-switchBase.Mui-checked': { color: INTERAX_COLORS.sun },
            '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
              backgroundColor: INTERAX_COLORS.sun,
              opacity: 0.6
            },
            '& .MuiSwitch-track': { backgroundColor: INTERAX_COLORS.thunderGrey }
          }}
        />
      }
    />
  )
}
